module.exports = __webpack_public_path__ + "img/circle-caret-left.cc6cd127.svg";